import { useState } from 'react';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import { PlaylistAssignmentsSearchProvider } from './PlaylistAssignmentsSearch';
import { UnAssignPlaylist, UnassignPlaylistHeader } from './UnAssignPlaylist';
import { usePlaylistAssignmentsPortals } from '../playlistAssignmentsQueries';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardMenuUnassignPlaylistOption = ({
  playlistId,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    playlistAssignmentsPortalsLoading,
    playlistAssignmentsPortals
  } = usePlaylistAssignmentsPortals({
    playlistId
  });
  const handleOnOpenChange = e => setIsOpen(e.target.value);
  const handleUnassignClick = () => setIsOpen(true);
  const handleOnUnassigned = (portalId, assignmentId) => {
    setIsOpen(false);
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  if (!isOpen && (playlistAssignmentsPortalsLoading || !playlistAssignmentsPortals || playlistAssignmentsPortals.length === 0)) {
    return null;
  }
  const shouldShowAssignees = !playlistAssignmentsPortalsLoading && playlistAssignmentsPortals && playlistAssignmentsPortals.length > 0;
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
    children: /*#__PURE__*/_jsx(CardMenu, {
      content: {
        header: /*#__PURE__*/_jsx(CardMenuHeader, {
          children: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
        }),
        body: shouldShowAssignees ? /*#__PURE__*/_jsx(UnAssignPlaylist, {
          onAssignmentClick: onAssignmentClick,
          onPortalClick: onPortalClick,
          onUnassigned: handleOnUnassigned,
          playlistId: playlistId
        }) : /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          padding: "400",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "extra-small"
          })
        })
      },
      onOpenChange: handleOnOpenChange,
      open: isOpen,
      placement: "right bottom",
      children: /*#__PURE__*/_jsx(SideNavItem, {
        "data-test-id": "unassign-playlist-button",
        iconRight: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-interactive-default",
          icon: RightIcon,
          paddingInline: "0",
          size: "100"
        }),
        onClick: handleUnassignClick,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.unassignPlaylist"
        })
      })
    })
  });
};
export default CardMenuUnassignPlaylistOption;